import type {AddRepresentativeNoteFormPayload} from "./add-representative-note.schema";

import {addRepresentativeNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

export function addRepresentativeNoteMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationKey: representativeMutationKeys.addRepresentativeNote,
    mutationFn: (formPayload: AddRepresentativeNoteFormPayload) =>
      addRepresentativeNote(representativeId, formPayload),
    onSuccess: async (_noteId, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
